export const setLineWidthByDistance = (distance: number) => {
  // distance -= RADIUS;
  let minDistance = 0;
  let maxDistance = 40000;
  const firstMinDistance = 0;
  const fisrtMaxDistance = 10000;
  const firstMinSize = 1;
  const firstMaxSize = 5;
  const secondMinDistance = 10000;
  const secondMaxDistance = 40000;
  const secoondMinSize = 5;
  const secondMaxSize = 50;

  if (firstMinDistance <= distance && distance <= fisrtMaxDistance) {
    return makeLogScale(
      distance,
      firstMinDistance,
      fisrtMaxDistance,
      firstMinSize,
      firstMaxSize
    );
  } else if (secondMinDistance <= distance && distance <= secondMaxDistance) {
    return makeLogScale(
      distance,
      secondMinDistance,
      secondMaxDistance,
      secoondMinSize,
      secondMaxSize
    );
  } else {
    return makeLogScale(
      distance,
      secondMinDistance,
      secondMaxDistance,
      secoondMinSize,
      secondMaxSize
    );
  }
};

export const setSizeByDistance = (distance: number) => {
  // distance -= RADIUS;
  let minDistance = 0;
  let maxDistance = 40000;
  const firstMinDistance = 0;
  const fisrtMaxDistance = 10000;
  const firstMinSize = 20;
  const firstMaxSize = 100;
  const secondMinDistance = 10000;
  const secondMaxDistance = 40000;
  const secoondMinSize = 100;
  const secondMaxSize = 200;

  if (firstMinDistance <= distance && distance <= fisrtMaxDistance) {
    return makeLogScale(
      distance,
      firstMinDistance,
      fisrtMaxDistance,
      firstMinSize,
      firstMaxSize
    );
  } else if (secondMinDistance <= distance && distance <= secondMaxDistance) {
    return makeLogScale(
      distance,
      secondMinDistance,
      secondMaxDistance,
      secoondMinSize,
      secondMaxSize
    );
  } else {
    return makeLogScale(
      distance,
      secondMinDistance,
      secondMaxDistance,
      secoondMinSize,
      secondMaxSize
    );
  }
};

export const makeLogScale = (
  value: number,
  inMin: number,
  inMax: number,
  outMin: number,
  outMax: number
) => {
  return Math.pow(
    ((value - inMin) / (inMax - inMin)) *
      (Math.log2(outMax) - Math.log2(outMin)) +
      Math.log2(outMin),
    2
  );
};
